import { RootState } from "../../../../safe-tasker-app react with typescript/src/Redux/Auth/types";

export const selectLoading = (state: RootState) => state.tasks.isLoading;

export const selectAllTasks = (state: RootState) => state.tasks.tasksUser;
